import { createSelector } from 'reselect';

const selectUser = (state) => state.applicants;

export const selectCandidates = createSelector(
  [selectUser],
  (applicants) => applicants.newCandidates
);

export const selectLoadingCandidates = createSelector(
  [selectUser],
  (applicants) => applicants.isFetchingCandidates
);

export const selectInViewCandidates = createSelector(
  [selectUser],
  (applicants) => applicants.keepInViewCandidates
);

export const selectLoadingInViewCandidates = createSelector(
  [selectUser],
  (applicants) => applicants.isFetchingkeepInViewCandidates
);

export const selectAdmittedCandidates = createSelector(
  [selectUser],
  (applicants) => applicants.admittedCandidates
);

export const selectLoadingAdmittedCandidates = createSelector(
  [selectUser],
  (applicants) => applicants.isFetchingadmittedCandidates
);

export const selectDeclinedCandidates = createSelector(
  [selectUser],
  (applicants) => applicants.declinedCandidates
);

export const selectLoadingDeclinedCandidates = createSelector(
  [selectUser],
  (applicants) => applicants.isFetchingdeclinedCandidates
);

export const selectApplications = createSelector(
  [selectUser],
  (applicants) => applicants.applications
);

export const selectSearchingApplications = createSelector(
  [selectUser],
  (applicants) => applicants.searchingApplication
);

export const selectLoadingApplications = createSelector(
  [selectUser],
  (applicants) => applicants.fetchingApplications
);

export const selectLoadingApplicantForm = createSelector(
  [selectUser],
  (applicants) => applicants.fetchingApplicantFormData
);

export const selectApplicantForm = createSelector(
  [selectUser],
  (applicants) => applicants.applicantFormData
);

export const selectLoadingFormSchema = createSelector(
  [selectUser],
  (applicants) => applicants.fetchingFormSchema
);

export const selectFormSchema = createSelector(
  [selectUser],
  (applicants) => applicants.formSchema
);

export const processingApplicant = createSelector(
  [selectUser],
  (applicants) => applicants.processingApplicant
);

export const selectNotifyingApplicants = createSelector(
  [selectUser],
  (applicants) => applicants.notifyingApplicants
);

export const selectDataExportLoading = createSelector(
  [selectUser],
  (applicants) => applicants.dataExportLoading
);

export const selectBatchProcessingApplicant = createSelector(
  [selectUser],
  (applicants) => applicants.batchProcessingApplicant
);

export const selectSendingEmail = createSelector(
  [selectUser],
  (applicants) => applicants.sendingEmail
);

export const preloadedCandidatesStatsLoading = createSelector(
  [selectUser],
  (applicants) => applicants.fetchingPreloadedCandidatesStats
);

export const preloadedCandidatesStats = createSelector(
  [selectUser],
  (applicants) => applicants.preloadedStats
);

export const loadingEmails = createSelector(
  [selectUser],
  (applicants) => applicants.fetchingEmail
);

export const selectLoadedEmails = createSelector(
  [selectUser],
  (applicants) => applicants.candidateEmail
);

export const loadingTransactions = createSelector(
  [selectUser],
  (applicants) => applicants.fetchingTransactions
);

export const selectLoadedTransactions = createSelector(
  [selectUser],
  (applicants) => applicants.candidateTransactions
);